import styled from 'styled-components';
import { Form } from 'antd';

export const StyledProductsTopFilter = styled(Form)`
    font-family: ${(props) => props.theme.fontText};
    display: flex;
    flex-direction: row;
    align-items: center;
    font-size: 14px;

    .icon {
        line-height: 24px;
    }

    .filter-order,
    .filter-page {
        border-right: 1px solid ${(props) => props.theme.borderBottom};
        padding-left: 20px;
    }

    .filter-page {
        padding-right: 20px;
    }
    
    .catalogue-number {
        border-right: 1px solid ${(props) => props.theme.borderBottom};
        padding-right: 20px;
        padding-left: 0;
    }
    
    .show-in-map {
        text-decoration: underline;
        cursor: pointer;
        color: ${({ theme }) => theme.profileSubTitle};
        transition: all 0.1s ease-in-out;
        padding-left: 20px;
        border-radius: 3px;
    }

    .ant-select-selection-item {
        font-size: 14px;
        font-weight: 400;
    }
`;
